/** Admin session (04-architecture § 12.2). */

import { create } from 'zustand';
import type { SseState } from '@cowoo/shared';

export type AdminRole = 'owner' | 'staff' | 'viewer';

export interface AdminProfile {
  userId: string;
  role: AdminRole;
  capabilities: string[];
  email: string;
  /** `null` until the operator has entered a name. */
  name: string | null;
  totpEnabled: boolean;
}

interface AdminState {
  token: string | null;
  profile: AdminProfile | null;
  /** The small dot in the avatar menu (10 § 20). */
  sse: SseState;
  setSession(token: string): void;
  setProfile(profile: AdminProfile): void;
  setSse(state: SseState): void;
  clear(): void;
  can(capability: string): boolean;
}

export const useAdminStore = create<AdminState>((set, get) => ({
  token: null,
  profile: null,
  sse: 'closed',
  setSession: (token) => set({ token }),
  setProfile: (profile) => set({ profile }),
  setSse: (sse) => set({ sse }),
  clear: () => set({ token: null, profile: null, sse: 'closed' }),
  // The server enforces the matrix; the UI only hides what it would refuse.
  can: (capability) => get().profile?.capabilities.includes(capability) ?? false,
}));
